import React from 'react';
import Image from 'react-bootstrap/Image';
import norway from '../../../images/norway.png';

function NorwayImage() {
    
    return  <Image src={norway} fluid alt="cart-ikon"/>;
    
}
export default NorwayImage;